/**
 * AverageLoanGapTrendChart — NOT_CONNECTED
 *
 * Loan gap data requires LOS integration.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const AverageLoanGapTrendChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.los}
      metricName="Average Loan Gap Trend"
    />
  );
};

export default AverageLoanGapTrendChart;